module.exports = __webpack_public_path__ + "img/fill-arrow-down.064b3cf5.svg";